module.exports = __webpack_public_path__ + "static/media/Icond-9.1f4b0755.svg";